export function iterator(length: number) {
  return [...new Array(length)];
}
